module.exports = __webpack_public_path__ + "static/img/3314_phase_function_Paper_PointsHejduk_Prediction.5c97636.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3314_phase_function_Paper_PointsHejduk_Prediction.png
// module id = sH0b
// module chunks = 0